import React from 'react';

import RetryPaymentRivertyBase from '../RetryPaymentRivertyBase/RetryPaymentRivertyBase';

import { Locale } from '@types-internal';

export type RetryPaymentRivertyInvoiceProps = {
  orderId: string;
  currency: string;
  siteId: number;
  customerId: string;
  sid?: string;
  amount: number;
  locale: Locale;
};

const RetryPaymentRivertyInvoice: React.FC<RetryPaymentRivertyInvoiceProps> = (props) => {
  return (
    <RetryPaymentRivertyBase
      {...props}
      notificationId="rivertyInvoicePaymentNotification"
      messageKey="mzp.order.detail.payment.riverty.invoice.reminder.message"
      noteKey="mzp.order.detail.payment.riverty.invoice.reminder.note"
      transferKey="mzp.order.detail.payment.riverty.invoice.reminder.transfer"
      alternativeKey="mzp.order.detail.payment.riverty.invoice.reminder.alternative"
    />
  );
};

export default RetryPaymentRivertyInvoice;
